import { useState } from "react";
import { Box, Flex, Collapse, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { BiChevronRight, BiChevronDown } from "react-icons/bi";
import { formatMoney } from "infra/helpers/number";
import TableItemReceita from "./../TabelaItemReceita/index";
import { RelatorioReceitasItem } from "core/features/relatorios/typings/index";

export interface ItemReceitaProps {
  item: RelatorioReceitasItem;
}

function ItemReceita({ item }: ItemReceitaProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((state) => !state);

  return (
    <Box>
      <Flex
        cursor="pointer"
        bg={colors.lightBlue}
        onClick={toggle}
        py={1}
        pr={6}
        pl={2}
        alignItems="center"
        borderBottom={`1px solid ${colors.gray}`}
      >
        <Flex alignItems="center" h="40px">
          {isOpen ? (
            <BiChevronDown size={25} color={colors.black700} />
          ) : (
            <BiChevronRight size={25} color={colors.black700} />
          )}
        </Flex>
        <Text ml={1} fontWeight="medium" fontSize="16px">
          {item.unidade ? item.unidade : ""}
          {item.unidade && item.proprietario ? " - " : ""}
          {item.proprietario ? item.proprietario : ""}
        </Text>

        {!isOpen ? (
          <Text ml={"auto"} fontWeight="bold">
            {formatMoney(item.valorTotal)}
          </Text>
        ) : null}
      </Flex>

      <Collapse in={isOpen}>
        <Box>
          <TableItemReceita item={item} />
        </Box>
      </Collapse>
    </Box>
  );
}

export default ItemReceita;
